import { useTranslation } from 'react-i18next';
import { FaFacebookSquare, FaPaw, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import { Reveal, RevealHeading, RevealGroup, RevealItem } from '../components/Reveal';

const EMAIL = 'etsukofci@gmail.com';
const PHONE_DISPLAY = '570 326 324';
const PHONE_HREF = '+48570326324';
const FACEBOOK = 'https://www.facebook.com/etsuko.fci';
const BREED_ARCHIVE =
  'https://japanesechin.breedarchive.com/breeder/view/agata-columbano-96617d4e-fd2c-4a27-b943-a3d88b3d55e4';

const ContactRow = ({ icon: Icon, label, children }) => (
  <div className="flex items-start gap-4">
    <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-brand-accent/30 bg-brand-accent/10 text-brand-accent">
      <Icon className="h-4 w-4" />
    </span>
    <div className="min-w-0">
      <p className="text-[0.7rem] uppercase tracking-[0.2em] text-brand-text-light/50">{label}</p>
      <div className="mt-1 text-lg text-brand-text-light break-words">{children}</div>
    </div>
  </div>
);

const ContactPage = () => {
  const { t } = useTranslation();

  return (
    <div className="animate-fadeIn">
      <section className="my-12 md:my-20 text-center">
        <RevealHeading as="h1" text={t('contact.title')} className="text-4xl md:text-5xl text-brand-accent" />
        <Reveal as="p" delay={0.18} className="mx-auto mt-4 max-w-2xl text-lg text-brand-text-light/75">
          {t('contact.subtitle')}
        </Reveal>
      </section>

      <Reveal delay={0.1} className="mx-auto max-w-3xl">
        <div className="rounded-2xl border border-brand-accent/20 bg-brand-bg-side/40 p-6 shadow-xl backdrop-blur-sm sm:p-10">
          <div className="text-center">
            <RevealHeading as="h2" text={t('contact.details.title')} className="text-2xl text-brand-accent sm:text-3xl" />
            <Reveal as="p" delay={0.15} className="mt-2 font-display text-xl text-brand-text-light/90">
              {t('contact.details.name')}
            </Reveal>
            <Reveal y={0} delay={0.25} className="mx-auto mt-5 h-px w-16 bg-gradient-to-r from-transparent via-brand-accent/70 to-transparent" />
          </div>

          <RevealGroup className="mt-8 grid gap-6 sm:grid-cols-2" stagger={0.1}>
            <RevealItem>
              <ContactRow icon={FaEnvelope} label="E-mail">
                <a
                  href={`mailto:${EMAIL}`}
                  className="transition-colors duration-300 hover:text-brand-accent focus:outline-none focus-visible:text-brand-accent"
                >
                  {EMAIL}
                </a>
              </ContactRow>
            </RevealItem>

            <RevealItem>
              <ContactRow icon={FaPhoneAlt} label="Telefon">
                <a
                  href={`tel:${PHONE_HREF}`}
                  className="transition-colors duration-300 hover:text-brand-accent focus:outline-none focus-visible:text-brand-accent"
                >
                  {PHONE_DISPLAY}
                </a>
              </ContactRow>
            </RevealItem>

            <RevealItem className="sm:col-span-2">
              <ContactRow icon={FaMapMarkerAlt} label="Lokalizacja">
                <span className="text-brand-text-light/80">{t('contact.details.location')}</span>
              </ContactRow>
            </RevealItem>
          </RevealGroup>

          <Reveal delay={0.15} className="mt-10 flex items-center justify-center gap-5 border-t border-brand-accent/15 pt-8">
            <a
              href={FACEBOOK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-brand-accent/30 text-brand-text-light/70 transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-accent hover:text-brand-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent"
            >
              <FaFacebookSquare size={22} />
            </a>
            <a
              href={BREED_ARCHIVE}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Breed Archive"
              className="flex h-12 w-12 items-center justify-center rounded-full border border-brand-accent/30 text-brand-text-light/70 transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-accent hover:text-brand-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent"
            >
              <FaPaw size={22} />
            </a>
          </Reveal>
        </div>
      </Reveal>
    </div>
  );
};

export default ContactPage;
